import React, { useState, useEffect, useRef } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import '../Styles/Navbar.css'; 
import { navbarConfig } from '../config/navbarConfig'; 
import DropdownMenu from './Navbar/DropdownMenu';  

const NavBar = () => {   
  const [activeDropdown, setActiveDropdown] = useState(null);   
  const [activeSubsection, setActiveSubsection] = useState(0);
  const dropdownRef = useRef(null);   
  const navigate = useNavigate();    

  useEffect(() => {     
    const handleClickOutside = (event) => {       
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {         
        setActiveDropdown(null);       
      }     
    };      
    
    // Listen for the custom event to open a specific dropdown
    const handleOpenDropdown = (event) => {
      const { section, subsection } = event.detail;
      
      // Find the index of the section in menuItems
      const sectionIndex = menuItems.findIndex(([key]) => key === section);
      
      if (sectionIndex !== -1) {
        setActiveDropdown(sectionIndex);
        
        // If there's a need to set active subsection in the dropdown
        if (typeof subsection === 'number') {
          setActiveSubsection(subsection);
        }
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('openNavDropdown', handleOpenDropdown);
    
    return () => {       
      document.removeEventListener('mousedown', handleClickOutside);     
      window.removeEventListener('openNavDropdown', handleOpenDropdown);
    };   
  }, []);    

  const handleDropdownClick = (index) => {     
    // Immediately update state for better responsiveness     
    requestAnimationFrame(() => {       
      setActiveDropdown(activeDropdown === index ? null : index);     
    });   
  };    

  const handleItemClick = (item) => {     
    if (item.route) {       
      // Immediately close dropdown       
      setActiveDropdown(null);              
      
      // Get current path and target path       
      const [targetPath] = item.route.split('#');       
      const currentPath = window.location.pathname;        
      
      // Navigate with replace to prevent history stack buildup       
      navigate(item.route, {         
        replace: currentPath === targetPath,         
        state: { instant: true }  // Add state to indicate instant navigation       
      });     
    }   
  };    

  const handleKeyDown = (index, section, e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      section.route ? handleItemClick(section) : handleDropdownClick(index);
    } else if (e.key === 'Escape') {
      setActiveDropdown(null);
    }
  };

  const menuItems = Object.entries(navbarConfig);

  return (
    <nav className="nav-links" ref={dropdownRef}>
      {menuItems.map(([key, section], index) => (
        <div
          key={key}
          className={`dropdown ${activeDropdown === index ? 'active' : ''}`}
        >
          <button
            type="button"
            onClick={() => section.route ? handleItemClick(section) : handleDropdownClick(index)}
            onKeyDown={(e) => handleKeyDown(index, section, e)}
            className="dropdown-trigger"
            aria-expanded={section.items ? activeDropdown === index : undefined}
            aria-haspopup={section.items ? 'true' : undefined}
          >
            {section.title}{' '}
            {!section.route && (
              <img
                src="https://cdn-icons-png.flaticon.com/128/10503/10503084.png"
                alt=""
                aria-hidden="true"
                className="dropdown-arrow"
              />
            )}
          </button>
          {activeDropdown === index && section.items && (
            <DropdownMenu
              items={section.items}
              onItemClick={handleItemClick}
              sectionName={section.title}
              activeSubsection={activeSubsection}
              setActiveSubsection={setActiveSubsection}
              onClose={() => setActiveDropdown(null)}
            />
          )}
        </div>
      ))}
    </nav>
  ); 
};  

export default NavBar;